import React from 'react';
import "../components/Services.css";

function Services() {
  return (
    <div className='services'>
        <h2>Our Services</h2>
            <div className='servicesContent'>
                <div className='cards'>
                    <div className='card-1'>
                        <h1>Web Applications</h1>
                        <img src='/images/iPhone.png' alt='iPhone' />
                    </div>
                    <div className='card-2'>
                        <h1>Websites</h1>
                        <img src='/images/macbook.png' alt='Macbook' />
                    </div>
                </div>
            </div>
    </div>
  );
}

export default Services;

